import React, { Fragment, useState } from 'react';
import {
    Checkbox,
    FormControlLabel,
    IconButton,
    InputAdornment,
    Tooltip,
    Typography,
} from '@mui/material';
import { Grid } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import CommonButton from '../../component/button/Button';
import AuthBg from '../../component/auth/AuthBg';
import Heading from '../../component/Heading/Heading';
import { SignInInputData } from '../../content/content';
import { NavLink } from 'react-router';
import InputComponent from '../../component/input/Input';
import { signIn } from '../../services/authenticationService';
import Toast from '../../component/toastify/Index';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import logo from "../../assets/icons/logo.svg"
import "../../styles/pages/auth/signUp.scss";
import "../../styles/pages/auth/SignIn.scss";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode';
import { useCommonContext } from '../../context/common';

const SignIn = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({});
    const [showPassword, setShowPassword] = useState(false); // New state for password visibility
    const [isPassword, setIsPassword] = useState(false);
    const { setIsAdmin } = useCommonContext();


    const [passwordCriteria, setPasswordCriteria] = useState({
        length: false,
        uppercase: false,
        number: false,
        noSpaces: false,
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === 'password') {
            setPasswordCriteria({
                length: value.length >= 8,
                uppercase: /[A-Z]/.test(value),
                number: /[0-9]/.test(value),
                noSpaces: !/\s/.test(value),

            });
            setIsPassword(true);
        }
    };

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prevShow) => !prevShow);
    };

    const validate = () => {
        let valid = true;
        const newErrors = {};

        SignInInputData.forEach((item) => {
            if (!formData[item.name]?.trim() && item.name != "password") {
                newErrors[item.name] = `${t(item.translationKey)} ${t("common_is_required")}`;
                valid = false;
            } else if (
                item.name === 'email' &&
                !/^\S+@\S+\.\S+$/.test(formData[item.name])
            ) {
                newErrors[item.name] = `${t('Telefonnummer darf 20 Ziffern nicht überschreiten')}`;
                valid = false;
            }
        });

        setErrors(newErrors);
        return valid;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsPassword(true);

        try {
            if (!validate() || !passwordCriteria.length || !passwordCriteria.noSpaces || !passwordCriteria.uppercase || !passwordCriteria.number) return;
            const response = await signIn(formData);
            if (response?.isSuccess) {
                localStorage.setItem('authToken', JSON.stringify(response.authToken));
                navigate('/dashboard');
                Toast(response?.message, 'success');
                if (response?.authToken) {
                    const decodedToken = jwtDecode(response.authToken);
                    setIsAdmin(decodedToken.isAdmin);
                }
            }
        } catch (error) {
            Toast(error?.message, 'error');
        }
    };

    return (
        <div className="auth sign-in">
            <div className="signup-container">
                <Grid container>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }} className="min-vh-100">
                        <div className="logo-container">
                            <img src={logo} alt="logo" className='company-logo' />
                        </div>
                        <form action="" onSubmit={handleSubmit}>
                            <div className="signup-data">
                                <div className="input-container">
                                    <Heading text={t('Willkommen')} />
                                    {SignInInputData.map((item, index) => (
                                        <div key={index} className="pt-2">
                                            {item.name === 'password' ? (
                                                <Fragment>
                                                    <Typography sx={{ display: "none" }}>Hover to see password requirements</Typography>
                                                    <InputComponent
                                                        type={showPassword ? 'text' : 'password'} // Toggle type
                                                        placeholder={t('Passwort einfügen')}
                                                        label={t('Passwort')}
                                                        className="input-field"
                                                        name={item.name}
                                                        value={formData[item.name] || ''}
                                                        onChange={handleChange}
                                                        required
                                                        isAuth
                                                        error={
                                                            !isPassword ? false :
                                                                !passwordCriteria.length ||
                                                                !passwordCriteria.uppercase ||
                                                                !passwordCriteria.number ||
                                                                !passwordCriteria.noSpaces
                                                        }
                                                        helperText={errors[item.name]}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment
                                                                    position="end"
                                                                >
                                                                    <IconButton
                                                                        onClick={handleTogglePasswordVisibility}
                                                                        edge="end"
                                                                    >
                                                                        {showPassword ? (
                                                                            <VisibilityOff className="text-blue" />
                                                                        ) : (
                                                                            <Visibility className="text-blue" />
                                                                        )}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />

                                                    <Typography className='password-validation' sx={{ display: !isPassword && "none", paddingTop: "10px" }}>
                                                        <p className='password-text' style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.length ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                                            {passwordCriteria.length ? (
                                                                <CheckIcon

                                                                    style={{ color: 'green', marginRight: '8px' }}
                                                                />
                                                            ) : (
                                                                <CloseIcon
                                                                    style={{ color: '#d32f2f', marginRight: '8px' }}
                                                                />
                                                            )}
                                                            {t('Mindestens 8 Zeichen')}
                                                        </p>
                                                        <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.uppercase ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                                            {passwordCriteria.uppercase ? (
                                                                <CheckIcon
                                                                    style={{ color: 'green', marginRight: '8px' }}
                                                                />
                                                            ) : (
                                                                <CloseIcon
                                                                    style={{ color: '#d32f2f', marginRight: '8px' }}
                                                                />
                                                            )}
                                                            {t('Mindestens ein Großbuchstabe')}
                                                        </p>
                                                        <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.number ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                                            {passwordCriteria.number ? (
                                                                <CheckIcon
                                                                    style={{ color: 'green', marginRight: '8px' }}
                                                                />
                                                            ) : (
                                                                <CloseIcon
                                                                    style={{ color: '#d32f2f', marginRight: '8px' }}
                                                                />
                                                            )}
                                                            {t('Mindestens eine Zahl')}
                                                        </p>
                                                        <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.noSpaces ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                                            {passwordCriteria.noSpaces ? (
                                                                <CheckIcon
                                                                    style={{ color: 'green', marginRight: '8px' }}
                                                                />
                                                            ) : (
                                                                <CloseIcon
                                                                    style={{ color: '#d32f2f', marginRight: '8px' }}
                                                                />
                                                            )}
                                                            {t('Keine Leerzeichen')}
                                                        </p>
                                                    </Typography>
                                                </Fragment>
                                            ) : (
                                                <InputComponent
                                                    type={item.type}
                                                    placeholder={t('E-Mail einfügen')}
                                                    label={t(item.translationKey)}
                                                    className="input-field"
                                                    name={item.name}
                                                    value={formData[item.name] || ''}
                                                    onChange={handleChange}
                                                    required
                                                    isAuth
                                                    error={!!errors[item.name]}
                                                    helperText={errors[item.name]}
                                                />
                                            )}
                                        </div>
                                    ))}
                                </div>

                                <div className="checkbox-container pt-4">
                                    <FormControlLabel
                                        label={t("Angemeldet bleiben")}
                                        control={
                                            <Checkbox
                                                sx={{
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: 30,
                                                        background: 'linear-gradient(to right, #F5D01C, #826320)',
                                                        WebkitBackgroundClip: 'text',
                                                        WebkitTextFillColor: 'transparent',
                                                        // Fallback for non-Webkit browsers (solid color)
                                                        color: '#F5D01C',
                                                    },
                                                }}
                                            />
                                        }
                                    />
                                    <p>
                                        <NavLink to="/forgot-password" className="signIn-link text-red w-100">
                                            {t("Passwort vergessen?")}
                                        </NavLink>
                                    </p>
                                </div>

                                <div className="signup-button">
                                    <CommonButton
                                        type="submit"
                                        text={t("Einloggen")}
                                        className="submit-button w-100"
                                    />
                                </div>
                                <div className="font-14 text-center">
                                    {t("Haben Sie noch kein Konto? ")}{' '}
                                    <span className="cursor-pointer">
                                        <NavLink to="/signUp" className="dark-blue">
                                            {t('Registrieren')}{' '}
                                        </NavLink>
                                    </span>
                                </div>
                            </div>
                        </form>
                    </Grid>

                    <Grid item size={{ xs: 12, md: 6, lg: 8 }} className="signup-img-padding">
                        <AuthBg />
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default SignIn;
